import { ServiceHealthStatus } from 'api3';
import { Injectable, inject, signal } from '@angular/core';
import { Api3Service } from './api3.service';

@Injectable({
  providedIn: 'root',
})
export class HealthService {
  healthStatus = signal<ServiceHealthStatus[]>([]);

  api3Service = inject(Api3Service);

  constructor() {
    this.checkHealthStatus();
  }

  async checkHealthStatus() {
    const { data, error } = await this.api3Service.api.status.getHealthStatus();
    if (error) {
      console.error('[HealthService] getHealthStatus error:', error);
      this.healthStatus.set([]);
      return;
    }
    this.healthStatus.set(data);
  }
}
